import { SafeResourceUrl } from "@angular/platform-browser";
import { IPhoneCallWebhook } from "voxloud-types/dist/models";
import { IPhoneCallTag, PhoneCallDirections, PhoneCallTypes } from "voxloud-types/dist/models/call-history/call-event.model";

export type TagError = 'required' | 'maxlength' | 'exists';

export interface IPhoneCallTagUI extends IPhoneCallTag {
  isEditing: boolean;
}
import { SmsCallDetails } from "voxloud-types/dist/models";

export interface UICallHistoryItem {
  id: number;
  type: PhoneCallTypes;
  number: string;
  from: string;
  to: string;
  fromFull: string;
  toFull: string;
  answererFull: string;
  contactCrm: string;
  contactCrmUrl: string
  contactCrmIconLink: string;
  answerer: string;
  duration: string | number;
  direction: PhoneCallDirections;
  timestamp: Date | string;
  labels: string[];
  ruleNames: string[];
  recorded: boolean;
  recordingUrl: string;
  answered: boolean;
  accountId: string;
  ringTime: number;
  maskCallerNumber: boolean;
  callLinks: {
    from: string,
    to: string,
    answerer: string
  },
  ai: {
    sentimentScore: number;
    transcription: string;
    summary: string;
    isProcessing:boolean;
    processingFailed: boolean;
    hasData: boolean;
  },
  //TODO: Put old model
  //webhooks: IPhoneCallWebhook[];
  webhooks: IWebhook[];
  voicemail: boolean;
  voicemailUrl: string;
  notes: string;
  tags: IPhoneCallTag[];
  sms?: SmsCallDetails[];
}

export enum TranscriptionStatus {
  PROCESSING = 'processing',
  FAILED = 'failed'
}

export const dateFormat = {
  short: 'MM/dd/yy HH:mm',
  long: 'MMM dd yyyy HH:mm:ss'
};

// TODO: Put old model
export interface IWebhook extends IPhoneCallWebhook {
  rule_name?: string;
}